import { Badge } from '@bambi/component-library/src/components/Badge/Badge';

import { PersonIcon } from 'src/common/primitives/icon/PersonIcon';

export function AttendantBadge({ name }: { name: string }) {
  return <Badge icon={<PersonIcon />} label={name} color="mint-inverse" />;
}
